<div class="row">
  <div class="col px-0">
    <div class="webbtree-banner-container">
      <div class="webbtree-banner">
        <div class="container pt-130">
         <div class="row sm-mobile">
          <div class="col-md-6">
            <div class="mini-tab-container">
              <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-1" class="nav-link active" id="pills-jobdescription-tab" data-bs-toggle="pill" data-bs-target="#pills-jobdescription" type="button" role="tab" aria-controls="pills-jobdescription" aria-selected="true" (click)="onTabChange('jd')"><i class="fas fa-file-magnifying-glass"></i> Job Description</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-2" class="nav-link" id="pills-search-tab" data-bs-toggle="pill" data-bs-target="#pills-search" type="button" role="tab" aria-controls="pills-search" aria-selected="false" (click)="onTabChange('quick')"><i class="fas fa-search"></i> Quick Search</button>
                </li>

              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-jobdescription" role="tabpanel" aria-labelledby="pills-jobdescription-tab">
                  <label class="f-14 font-weight-500 mb-2">Upload JD</label>

                  <div class="ats-upload-btn d-flex justify-content-center align-items-center mb-4">

                    <div  class="col text-left p-2" *ngIf="!isUploadedFileCorrect">
                      <div class="" >
                        <p class="font-weight-normal text-bluex mb-0">
                          <i class="fas fa-upload"></i> &nbsp;Upload your Job Description
                        </p>
                      </div>
                    </div>
                    <input data-testid="auto-app-webbtree-freemium-banner-input-1"  type="file" #document (change)="uploadFile($event)" *ngIf="!isUploadedFileCorrect"
                      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                      <div class="text-center d-flex my-3" *ngIf="isUploadedFileCorrect">
                        <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                        {{ uploadedFilename }}
                        <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove</p>
                      </div>

                  </div>
                  <div class="position-relative pt-2 mb-1">
                    <label class="f-14 font-weight-500 mb-2">Paste JD</label>

                    <textarea data-testid="auto-app-webbtree-freemium-banner-textarea-1" type="text" placeholder="Paste your Job Description" [(ngModel)]="enteredJobDescription"
                      class="wc-textarea wc-form-control mb-2" rows="6"></textarea>
                  </div>
                  <div class="text-center">
                     <button data-testid="auto-app-webbtree-freemium-banner-button-3"  class="btn-get-talent-insight" [disabled]="isFreemiumDescriptionEmpty" [ngStyle]="{'opacity': isFreemiumDescriptionEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights()">Get Talent Insights</button>
                  </div>
                </div>
                <div class="tab-pane fade" id="pills-search" role="tabpanel" aria-labelledby="pills-search-tab">
                  <div class="mb-5 position-relative">
                    <label class="f-14 font-weight-500 mb-2">Job Title</label>
                    <input data-testid="auto-app-webbtree-freemium-banner-input-2" type="text" class="wc-form-control mb-2" placeholder="Enter a job title(s)" [formControl]="jobTitleInput"
                    (keyup.enter)="selectedItem($event,'jobtitle');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'jobtitle')"
                    [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
                   >
                    <div *ngIf="jobtitleLoader" class=" spinner-border position-absolute text-black" style="top: 30px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
                      <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{jt.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #jobtitle_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let jobtitle of jobTitleSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{jobtitle.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(jobtitle, 'jobtitle')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                    <div class="mb-5 position-relative">
                      <label class="f-14 font-weight-500 mb-2">Skills</label>

                    <input data-testid="auto-app-webbtree-freemium-banner-input-3" type="text" class="wc-form-control mb-2" placeholder="Enter a skill(s)" [formControl]="skillInput"
                    (keyup.enter)="selectedItem($event,'skill');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'skill')"
                    [matAutocomplete]="skill_auto" [matChipInputFor]="skill_chipList"
                    >
                    <div *ngIf="skillsLoader" class=" spinner-border position-absolute text-black" style="top: 30px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #skill_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skill')">
                      <mat-option *ngFor="let st of skillTitleList" [value]="{key: st.value, doc_count: st.doc_count}" [matTooltip]="st.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{st.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #skill_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let skill of skillsSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{skill.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(skill, 'skill')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>

                  <div class="mb-6 position-relative">
                    <label class="f-14 font-weight-500 mb-2">Locations</label>

                    <div class="d-flex">
                    <span class="dropdown ats-dropBtn">
                      <button data-testid="auto-app-webbtree-freemium-banner-button-4" class="dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton"
                        appDropdownToggle aria-haspopup="true" aria-expanded="false">
                        <div class="d-flex align-items-center text-truncate" [ngStyle]=" { 'width': '80px'}">
                          <i class="fas fa-earth mr-1"></i>
                          <span class="text-capitalize mr-1 text-truncate">{{showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa': showregion == 'north america' ? 'North America': showregion == 'oceania' ? 'Oceania': 'South America'}}</span>
                          <i class="fas fa-chevron-down f-14"></i>
                        </div>
                      </button>
                      <div class="dropdown-menu"
                      aria-labelledby="userDropdownButton">
                        <div class="d-flex justify-content-between mb-3">
                            <p class="f-14 continentdropdown font-weight-500 text-black mb-0">Select Continent</p>
                            <div>
                                <span><i class="fas fa-times pointer"></i></span>
                            </div>

                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1  pointer"
                                    [ngClass]="{'border-blue': showregion === 'north america',  'border-gray': showregion !== 'north america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('north america')">
                                    <img src="../../assets/images/north-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">North America</p>
                            </div>
                            <div>
                                <div class="region-box  mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'asia',  'border-gray': showregion !== 'asia'}"
                                    (click)="selectRegion('asia')">
                                    <img src="../../assets/images/asia.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Asia</p>
                            </div>
                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'south america', 'border-gray': showregion !== 'south america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('south america')">
                                    <img src="../../assets/images/south-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">South America</p>
                            </div>
                            <div>
                                <div class="region-box border-gray mb-1"
                                    [ngClass]="{'border-blue': showregion === 'africa', 'border-gray': showregion !== 'africa'}" (click)="selectRegion('africa')">
                                    <img src="../../assets/images/africa.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Africa</p>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'oceania', 'border-gray': showregion !== 'oceania'}"
                                    style="margin-right: 18px;" (click)="selectRegion('oceania')">
                                    <img src="../../assets/images/oceania.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black  continentdropdown f-14 mb-0">Oceania</p>
                            </div>
                        </div>
                      </div>
                    </span>
                    <input data-testid="auto-app-webbtree-freemium-banner-input-4" type="text" class="wc-form-control mb-2" placeholder="Enter a Location(s)" [formControl]="locationInput"
                    (keyup.enter)="selectedItem($event,'location');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'location')"
                    [matAutocomplete]="location_auto" [matChipInputFor]="location_chipList"
                   >
                    <div *ngIf="locationsLoader" class=" spinner-border position-absolute text-black" style="top: 35px; right: 20px; z-index: 2;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
                      <mat-option *ngFor="let lt of locationTitleList" [value]="{key: lt.value, doc_count: lt.doc_count}" [matTooltip]="lt.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{lt.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>

                    <mat-chip-grid #location_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let location of locationSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{location.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(location, 'location')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                  <div class="text-center">
                    <button data-testid="auto-app-webbtree-freemium-banner-button-5"  class="btn-get-talent-insight" [disabled]="isFreemiumQuickSearchEmpty" [ngStyle]="{'opacity': isFreemiumQuickSearchEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights()">Get Talent Insights</button>
                 </div>
                </div>

              </div>
            </div>
            <div class="xs-slider-container">
              <div id="container2">
                <div class="photobanner">
                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">
                </div>
              </div>

              <p class="f-14 font-weight-500 text-black">
                5,000+ TA Professionals are using Webbtree to discover top talent
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div>
            <h1 class="f-36 font-weight-600 text-black mb-5" style="line-height: 1.5;">
              Elevate Your Sourcing<br> Strategy with <span class="text" style="color: #c845ab;">AI-Driven</span> <br> Insights & Intelligence
            </h1>
            <p class="f-16 mb-5 line-height-1 text-black col-md-11 px-0">Upload a JD or fill in your requirements to view your Talent Insights Report. Enhance your sourcing efforts and connect with top talent effectively</p>
            <div id="container3">
              <div class="photobanner">
                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">
              </div>
            </div>

            <p class="f-14 font-weight-500 text-black">
              5,000+ TA Professionals are using Webbtree to discover top talent
            </p>
          </div>
          </div>
         </div>
         <div class="spacer">&nbsp;</div>
         <div class="spacer">&nbsp;</div>
         <!-- <div class="spacer">&nbsp;</div> -->
        </div>
    </div>
    </div>

      <!-- <div class="talent-insights-load"  *ngIf="showQuickSearchLoader">
        <div class="generate_loader text-center align-items-center justify-content-between" style="height: 650px;">
          <p><i class="fa-regular fa-spinner mr-2"></i>Generating Talent Insights
          </p>
        </div>

      </div> -->


    <div class="container" *ngIf="!showInsights && !showQuickSearchLoader">
      <div class="row mb-6 mb-2">
        <div class="col text-center">
          <h2 class="f-30 font-weight-600 text-black">Unlock Full Access with a 7-Day Free Trial</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-wrap">
            <div class="free-access-tiles bgimg1">
              <p class="mb40px">Analyze diverity insights to build inclusive teams.</p>
              <!-- <div>
                <img src="../../../assets/webbtree-freemium/Analyze-diverity-insights1.svg" class="img-fluid" alt="" srcset="">
              </div> -->
              <div class="onhover-layer">
                <button data-testid="auto-app-webbtree-freemium-banner-button-6" (click)="openFreeTrial('Diversity_Insights_Start_Free_Trial_Click')">
                  Start Free Trial <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="free-access-tiles bgimg2">
              <p class="mb40px">Track talent movement to source from growing or shrinking companies.</p>
              <!-- <div>
                <img src="../../../assets/webbtree-freemium/Track-talent-movement1.svg" class="img-fluid" alt="" srcset="">
              </div> -->
              <div class="onhover-layer">
                <button data-testid="auto-app-webbtree-freemium-banner-button-7" (click)="openFreeTrial('Talent_Movement_Start_Free_Trial_Click')">
                  Start Free Trial <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="free-access-tiles bgimg3">
                <p class="mb40px">Discover top skills and titles for high-demand roles.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Discover-top-skills-and-titles1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-8" (click)="openFreeTrial('Discover_Skills_Title_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg4">
                <p class="mb40px">Leverage seniority and nationality insights for targeted sourcing.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Leverage-seniority-and-nationality-insights1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-9" (click)="openFreeTrial('Leverage_Seniority_Nationality_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg5">
                <p class="mb40px">Target candidates using company talent flow and attrition trends.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Target-candidates1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-10" (click)="openFreeTrial('Talent_Flow_Attrition_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg6">
                <p class="mb40px">Access 610M+ profiles with contact information for outreach.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Access-profiles-with-contact1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-webbtree-freemium-banner-button-11" (click)="openFreeTrial('Contact_Information_Outreach_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer">&nbsp;</div>
    <ng-template #container id="insightsProfile">
      <div #contentRef >
        <app-insights-profile-section [tabname]="tabName"></app-insights-profile-section>

      </div>
    </ng-template>
    <div class="spacer">&nbsp;</div>
    <div #contentUpgrade style="margin-top: 30px;" *ngIf="!showInsights">
      <app-seven-day-free-trial-form></app-seven-day-free-trial-form>
    </div>
    <div class="spacer">&nbsp;</div>
  </div>
</div>

<app-webbtree-footer></app-webbtree-footer>
